import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  err: Error | null;
}

// Red de seguridad: si una pantalla lanza un error en render, muestra un aviso en
// lugar de dejar la app en blanco. Se resetea al navegar (la key cambia por ruta).
export class ErrorBoundary extends Component<Props, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 28, textAlign: 'center' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>⚠️</div>
          <p>Algo falló al mostrar esta pantalla.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 12,
              padding: '12px 18px',
              borderRadius: 12,
              border: 'none',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
